import { VehicleStateEnum } from 'src/api';

export type VehicleStateById = Record<string, string | undefined>;

export type BulkDeleteSplit = {
	deletable: string[];
	blocked: string[];
};

export type BulkDeleteProgress = {
	done: number;
	total: number;
};

export type BulkDeleteOutcome = {
	deleted: string[];
	failed: string[];
};

export const stateByIdOf = (
	rows: { id: string; stato_corrente?: { type?: string } }[]
): VehicleStateById =>
	rows.reduce<VehicleStateById>((acc, row) => {
		acc[row.id] = row.stato_corrente?.type;
		return acc;
	}, {});

/**
 * Si elimina solo un veicolo DISPONIBILE.
 */
export const splitByDeletable = (
	ids: string[],
	stateById: VehicleStateById
): BulkDeleteSplit => {
	const split: BulkDeleteSplit = { deletable: [], blocked: [] };

	Array.from(new Set(ids)).forEach((id) => {
		const target =
			stateById[id] === VehicleStateEnum.DISPONIBILE
				? split.deletable
				: split.blocked;
		target.push(id);
	});

	return split;
};

export const deleteEach = async (
	ids: string[],
	deleteOne: (id: string) => Promise<unknown>,
	onProgress: (progress: BulkDeleteProgress) => void
): Promise<BulkDeleteOutcome> => {
	const outcome: BulkDeleteOutcome = { deleted: [], failed: [] };

	for (const [index, id] of ids.entries()) {
		try {
			await deleteOne(id);
			outcome.deleted.push(id);
		} catch {
			outcome.failed.push(id);
		}

		onProgress({ done: index + 1, total: ids.length });
	}

	return outcome;
};
